import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Separator } from '@/components/ui/separator';
import PageMeta from '@/components/SEO/PageMeta';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <PageMeta 
        title="Mentions Légales La Patrimoniale - Cabinet de Patrimoine Paris"
        description="Mentions légales officielles de La Patrimoniale, cabinet de gestion de patrimoine à Paris. Retrouvez toutes les informations légales, identification de l'entreprise, immatriculation, direction et hébergeur. La Patrimoniale accompagne ses clients dans l'acquisition, la protection et l'optimisation fiscale de leur patrimoine avec expertise et professionnalisme."
        keywords="La Patrimoniale, mentions légales La Patrimoniale, gestion patrimoine Paris, société civile, identification entreprise patrimoine, direction La Patrimoniale, hébergeur site La Patrimoniale, informations légales cabinet, immobilier, patrimoine Paris"
        canonical="https://www.la-patrimoniale-gestion.com/mentions-legales"
      />
      <Navbar />
      <main className="flex-grow pt-24 pb-16">
        <div className="container mx-auto px-4 md:px-6">
          <h1 className="text-3xl md:text-4xl font-serif font-bold text-patrimoine-dark mb-8">Mentions Légales</h1>
          
          <Separator className="mb-8" />
          
          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-serif font-semibold text-patrimoine-dark mb-4">Informations sur l'entreprise</h2>
              <div className="space-y-2">
                <p><strong>Dénomination sociale :</strong> LA PATRIMONIALE</p>
                <p><strong>Forme juridique :</strong> Autre société civile</p>
                <p><strong>Capital social :</strong> 10 099 700,00 €</p>
                <p><strong>Siège social :</strong> 47 BOULEVARD DE BEAUSEJOUR, 75016 PARIS</p>
                <p><strong>Activité :</strong> Acquisition et gestion en commun de valeurs mobilières, parts d'intérêts, droits mobiliers et immobiliers</p>
                <p><strong>Code NAF ou APE :</strong> 64.30Z (Fonds de placement et entités financières similaires)</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-semibold text-patrimoine-dark mb-4">Immatriculation</h2>
              <div className="space-y-2">
                <p><strong>SIREN :</strong> 319 617 809</p>
                <p><strong>SIRET (siège) :</strong> 319 617 809 00011</p>
                <p><strong>Numéro RCS :</strong> 319 617 809 R.C.S. Paris</p>
                <p><strong>Inscription au RCS :</strong> Inscrit au greffe de PARIS, le 01/09/1980</p>
                <p><strong>Inscription au RNE :</strong> Inscrit le 01/09/1980</p>
                <p><strong>Numéro de TVA :</strong> FR00319617809</p>
                <p><strong>Date de création :</strong> 01/08/1980</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-semibold text-patrimoine-dark mb-4">Direction</h2>
              <div className="space-y-2">
                <p><strong>Dirigeants :</strong></p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>M. Vincent Hollard</li>
                  <li>Mme. Beatrice Beau</li>
                  <li>Mme. Agnes Grunelius</li>
                  <li>M. Antoine Hollard</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-semibold text-patrimoine-dark mb-4">Convention collective</h2>
              <p>Convention collective supposée : Établissements financiers - IDCC 478</p>
            </section>

            <section>
              <h2 className="text-2xl font-serif font-semibold text-patrimoine-dark mb-4">Hébergement du site</h2>
              <p>
                Le site web de LA PATRIMONIALE est hébergé par Vercel Inc., 340 S Lemon Ave #4133, Walnut, CA 91789, USA.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MentionsLegales;
